import {getCardType} from "./utility";
export const trackAdobeDncPages = (ComponentName, currentAppState, adobeEventName, userDetail, dynamicObject = {}) => {
  // need to main tain global state for adobe configuration checking that is pending
  const setAdobeDncconfig = async () => {
    var { adobe_object } = window.global;
    const adobeArray = [];
    let req_fields = [];
    var pageExist = [];
    let fieldValues = [];
    pageExist = adobe_object?.datalayerParams.filter(i => i.page?.abobeInclude && i.page?.screenInfo?.componentName === ComponentName
      && i.page.screenInfo.adobeIncludeOnLoad)
    if (pageExist.length) {
      // start dncadobeconfig page data
      adobeArray["pageName"] = pageExist[0].page?.pageInfo?.pageName;
      adobeArray["pageURL"] = pageExist[0].page?.pageInfo?.pageURL;
      adobeArray["siteIdentifier"] = pageExist[0].page?.siteIdentifier;
      adobeArray["primaryCategory"] = pageExist[0].page?.primaryCategory;
      adobeArray["platform"] = pageExist[0].page?.platform;
      let default_val;
      let apiresponseStatus = "";
      let decisionCode = "";
      let reason = "";
      let adobePageForm;
      if (pageExist[0].page?.isReusable && Object.entries(dynamicObject).length > 0 && dynamicObject.hasOwnProperty("wipStepName")) {
        default_val = dynamicObject.wipStepName;
        adobePageForm = pageExist[0][default_val]?.form[0];
        if (adobePageForm?.responseStatus?.abobeinclude && adobePageForm?.responseStatus?.storedValue === "default" && dynamicObject.hasOwnProperty("wipDefaultstaus")) {
          //for WIP case like CompleteApplication_Default where BE response is not specific 
          apiresponseStatus = dynamicObject.wipDefaultstaus;
          decisionCode = dynamicObject.wipDefaultstaus;
          reason = dynamicObject.wipDefaultstaus;
        } else {
          decisionCode = adobePageForm?.decisionCode?.abobeinclude ? adobePageForm.decisionCode.storedValue : "";
        }
      } else {
        default_val = "default";
        adobePageForm = pageExist[0][default_val]?.form[0];
        decisionCode = adobePageForm?.decisionCode?.abobeinclude ? adobePageForm.decisionCode.storedValue : "";
      }
      //************************** default_val cases starts*******************************************//
      adobeArray["subCategory2"] = adobePageForm?.subCategory2 ? adobePageForm.subCategory2 : "";
      adobeArray["formStepName"] = (adobePageForm?.formStepNameabobeinclude && adobePageForm?.formStepName) ? adobePageForm.formStepName : "";
      adobeArray["formName"] = adobePageForm?.formName ? adobePageForm.formName : "";
      adobeArray["milestone"] = (adobePageForm?.haveMilestoneadobe && adobePageForm?.mileStoneName) ? adobePageForm.mileStoneName : "";
      adobeArray["status"] = adobePageForm?.responseStatus?.abobeinclude ? adobePageForm.responseStatus.storedValue : apiresponseStatus;
      adobeArray["decisionCode"] = decisionCode;
      adobeArray["reason"] = adobePageForm?.reason?.abobeinclude ? adobePageForm.reason.storedValue : reason;
      if (adobePageForm?.formFieldAbobeinclude) {
        req_fields = adobePageForm?.fields.filter(j => j.abobeinclude)
      }
      if (req_fields) {
        req_fields.forEach((ele, i) => {
          adobeArray["fieldName"] = req_fields[i]?.fieldName;
          adobeArray["elementName"] = req_fields[i]?.elementName;
          adobeArray["fieldType"] = req_fields[i]?.fieldType;
          // eslint-disable-next-line
          if (adobeArray["fieldType"] === "store" && (eval(adobeArray["elementName"]) !== "" || eval(adobeArray["elementName"]) !== "null" || eval(adobeArray["elementName"]) !== "undefined")) {
            // eslint-disable-next-line
            fieldValues[i] = `${adobeArray["fieldName"]}:${eval(adobeArray["elementName"])}`;
          }
        })
        let str = [];
        str = fieldValues.join('|');
        fieldValues = str.toString();
      }
    }

    const event = pageExist[0].event?.filter(e =>
      e.abobeInclude && e.adobeEventName === adobeEventName
    )
    adobeArray["event"] = event[0]?.adobeEventName;
    adobeDataLayerScript(adobeArray, currentAppState, userDetail, fieldValues);
  }
  setAdobeDncconfig();

}

const getAbobeObject = (adobeArray, currentAppState, userDetail, fieldValues) => {

  let cardType = getCardType(currentAppState?.cardListDetails?.cardType,userDetail?.cardType);
  let cardName = currentAppState?.cardListDetails?.uniqueIdentifier && currentAppState?.cardListDetails?.uniqueIdentifier !== undefined ? currentAppState.cardListDetails.uniqueIdentifier : "";
  const gemId1 = localStorage.getItem("gemId1");
  const gemId2 = localStorage.getItem("gemId2");
  const shortcode = localStorage.getItem("cShortCode");// campaign short code
  const leadsourceCode = userDetail?.shortCode;
  const pageName = adobeArray["siteIdentifier"] + ":" + adobeArray["primaryCategory"] + ":" + cardName + ":" + adobeArray["subCategory2"] + ":" + adobeArray['pageName']
  let newobj = {};
  const pageURL = window.location.href;
  let pageViewObj = {
    "event": adobeArray['event'],
    "page": {
      "pageInfo": {
        "pageName": pageName,
        "pageURL": pageURL,
      },
      "category": {
        "primaryCategory": adobeArray["primaryCategory"],
        "subCategory1": cardName,
        "subCategory2": adobeArray["subCategory2"],
        "platform": adobeArray["platform"],
      },
    },
    "card": {
      "cardName": cardName,
      "cardType": cardType,
      "channel": "SAPL" //userdetail not accessible on page load
    },
    "campaign": {
      "gemID1": gemId1 !== "null" ? gemId1 : "",
      "gemID2": gemId2 !== "null" ? gemId2 : "",
      "csCode": shortcode !== "null" ? shortcode : "", //campaign short code
    }
  }
  if (adobeArray['event'] === 'pageView') {
    newobj = {
      ...pageViewObj,
      "form": {
        "formName": adobeArray["formName"],
        "formStepName": adobeArray["formStepName"]
      }
    }
  }
  else if (adobeArray["event"] === 'formStart') {
    newobj = {
      ...pageViewObj,
      "mileStoneEvent": adobeArray["milestone"],
      "form": {
        "formName": adobeArray["formName"],
        "formStepName": adobeArray["formStepName"]
      },
      "CTAClick": {
        "CTAName": "",
        "CTAType": "", // button, link, image
        "CTAPosition": "", // header, body, footer, navigation panel
      }
    }
  }
  else if (adobeArray["event"] === 'formStep') {
    newobj = {
      ...pageViewObj,
      "mileStoneEvent": adobeArray["milestone"],
      "form": {
        "formName": adobeArray["formName"],
        "formStepName": adobeArray["formStepName"],
        "leadID": leadsourceCode,
        "formFields": fieldValues, //Pass only if applicable
        "status": adobeArray["status"],  //blank
        "decisionCode": adobeArray["decisionCode"],
        "reason": adobeArray["reason"]
      }
    }
  } else if (adobeArray["event"] === 'errorPage') {
    var siteError = adobeArray["status"] + ":" + adobeArray["reason"] + "|" + fieldValues; //Pass this field only if applicable //blank
    pageViewObj["page"]["category"]["siteError"] = siteError;
    newobj = {
      ...pageViewObj,
      "form": {
        "formName": adobeArray["formName"],
        "formStepName": adobeArray["formStepName"],
        "leadID": leadsourceCode,
      }
    }
  }

  return newobj;
};

export const getAbobeObjectCTAClick = (userDetail, currentAppState, fieldObj,from_page,sd1_page_name) => {
  const cardName = currentAppState?.cardListDetails?.uniqueIdentifier;
  const cardType = currentAppState?.cardListDetails?.cardType;
  const gemId1 = localStorage.getItem("gemId1");
  const gemId2 = localStorage.getItem("gemId2");
  const shortcode = localStorage.getItem("cShortCode");// campaign short code
  let formFields ="";
  let pageName = "";
  let CTAName = "";
  let milestoneName = "";
  let formStepName = "";
  let subCategory2 = "";
  // const ResiAddr= userDetail?.resiAddr;
  //const Resiaddrfields = `AddressType:${fieldObj?.addressType}|city:${fieldObj?.city}|houseNo:${fieldObj?.houseNo}|landmark:${fieldObj?.landmark}|locality:${fieldObj?.locality}|pin:${fieldObj?.pin}|resiAddressLine2:${fieldObj?.resiAddressLine2}|state:${fieldObj?.state}`;
  if(from_page=== "SD2"){
    formFields = `City:${fieldObj?.city}|State:${fieldObj?.state}`
    pageName = `sbi-card:SPRINT application:${cardName}:KYC digilocker:Digilocker Residential Address`;
    CTAName = "Confirm";
    milestoneName = "SoftDecision2Submit";
    formStepName = "Digilocker Residential Address";
    subCategory2 = "KYC digilocker";
  }
  else if(from_page=== "SD1"){
    var formStepName_val ;
    if(sd1_page_name==="Occupation Details")
    formStepName_val = "Occupation Details";
    else
    formStepName_val = "Workplace Address";
    const companyCategory = `${userDetail.companyCategory}`;
    if(companyCategory==="")
    formFields = `City:${userDetail.resiCity}|Occupation Type:${userDetail.occupation}`;
    else
    formFields = `City:${userDetail.resiCity}|Occupation Type:${userDetail.occupation}|Company Category:${userDetail.companyCategory}`;
    pageName = `sbi-card:SPRINT application:${cardName}:Professional Details:${sd1_page_name}`;
    CTAName = "Continue to step 3";
    milestoneName = "SoftDecision1Submit";
    formStepName = formStepName_val;
    subCategory2 = "Professional Details";
  }
  const pageURL = window.location.href;
  let clickObj = {
    "event": "CTAClick",
    "page": {
      "pageInfo": {
        "pageName": pageName,
        "pageURL": pageURL,
      },
      "category": {
        "primaryCategory": "SPRINT application", // pass “sprint application”
        "subCategory1": cardName, // Pass Card Name
        "subCategory2": subCategory2,// Pass section of the form journey
        "platform": "web"
      },
    },

    "CTAClick": {
      "CTAName": CTAName,
      "CTAType": "button", // button, link, image
      "CTAPosition": "body", // header, body, footer, navigation panel
    },

    "card": {
      "cardName": cardName,
      "cardType": cardType,
      "channel": "SAPL"
    },
    "campaign": { 
      "gemID1": gemId1 !== "null" ? gemId1 : "",
      "gemID2": gemId2 !== "null" ? gemId2 : "",
      "csCode": shortcode !== "null" ? shortcode : "", //campaign short code
    },

    "mileStoneEvent": milestoneName,//Pass only if applicable

    "form": {
      "formName": "SPRINT Application Form",
      "formStepName": formStepName,
      "leadID": userDetail?.shortCode,
      "formFields": formFields, //Pass only if applicable
      "photoMatchPerc": "", //Pass this field only if applicable
      "status": from_page, //Pass this field only if applicable
      "decisionCode": "",
      "reason": "" //Pass this field only if applicable
    }
  }
  if (window.adobeDataLayer)
    window.adobeDataLayer.push(clickObj);
};

export const adobeDataLayerScript = (adobeArray, currentAppState, userDetail, fieldValues) => {
  let adobeObject = getAbobeObject(adobeArray, currentAppState, userDetail, fieldValues);
  if (window.adobeDataLayer)
    window.adobeDataLayer.push(adobeObject);

};